import * as _ from 'lodash';
import * as React from 'react';

interface ISelectProps<T, IndexProp extends keyof T> {
  options: T[] | _.Dictionary<T[]>
  valueKey: IndexProp
  onChange: (value: T[IndexProp]) => void
  label: string;
  disabledSort?: boolean
  readOnly?: boolean
  required?: boolean
  value?: T[IndexProp]
  loading?: boolean
  loadingText?: string
  labelKey?: keyof T
}

export class Select<T, IndexProp extends keyof T> extends React.Component<ISelectProps<T, IndexProp>, {}> {
  onChange(value: string) {
    const { onChange, options, valueKey } = this.props
    let selectedOption: T;

    if (options instanceof Array) {
      selectedOption = options.find((o) => String(o[valueKey]) === value)
    } else {
      // @ts-ignore
      selectedOption = _(options).values().flatten().find((o) => String(o[valueKey]) === value)
    }

    if (selectedOption) {
      onChange(selectedOption[valueKey])
    }
  }

  renderOption(option: T) {
    const { valueKey, labelKey } = this.props
    const optionValue = String(option[valueKey])
    const optionLabel = option[labelKey]

    return (
      <option key={optionValue + optionLabel} value={optionValue}>{optionLabel}</option>
    )
  }

  render() {
    const { options, value, valueKey, labelKey = valueKey, label, loading = false, required = false, readOnly = false, disabledSort = false } = this.props
    const { loadingText = 'Loading...' } = this.props
    const valueStr = value ? String(value) : ''
    //const disabledValue = typeof value === 'number' ? '-1' : ''

    if (!disabledSort) {
      const labelSorter = (o1: T, o2: T) => {
        const o1Label = String(o1[labelKey])
        const o2Label = String(o2[labelKey])

        return o1Label.localeCompare(o2Label)
      }

      if (options instanceof Array) {
        options.sort(labelSorter)
      } else {
        for (const groupKey in options) {
          if (groupKey in options) {
            options[groupKey] = options[groupKey].sort(labelSorter)
          }
        }
      }
    }

    return (
      <select className="form-control browser-default"
        disabled={loading || readOnly}
        onChange={(e) => this.onChange(e.target.value)}
        value={valueStr}
        required={required}>
        {loading ?
          <option key="Loading Placeholder" value={valueStr} disabled>{loadingText}</option>
          :
          <option key="Selecting Placeholder" value="" disabled>Select {label}</option>

        }
        {options instanceof Array && options.map((option) => this.renderOption(option))}
        {!(options instanceof Array) && Object.keys(options).map((groupOptionKey) =>
          <optgroup key={groupOptionKey} label={groupOptionKey}>
            {options[groupOptionKey].map((option) => this.renderOption(option))}
          </optgroup>
        )}
      </select>
    )
  }
}
